import { createContext } from "react";

const TabNameContext = createContext();

export default TabNameContext;